import { observer, useLocalObservable } from 'mobx-react';
import { INV_TYPE_TABS, encodeAllInvestmentsParams, invTypePageSize } from '../constants';
import useHistory from '../../../hooks/useHistory';
import { paths } from '../../../utils/constants/routes';
import { useStore } from '../../../store/store';
import Pagination from '../../../components/navigation/Pagination';
import AllInvestmentsListEntry from './AllInvestmentsListEntry';
import { useEffect } from 'react';

const AllInvestmentsList = observer(({ list = [], params = {} }) => {
  const { fundsStore, authStore, utilsStore } = useStore();
  const { navigate } = useHistory();

  const state = useLocalObservable(() => ({
    get layout() {
      return utilsStore.windowWidth < 1201 ? 'mobile' : 'desktop';
    }
  }));

  useEffect(() => {
    authStore.loadCompanyUsers();
    fundsStore.loadCompanyFunds();
  }, [authStore]);

  const type = params.tab;

  const nonCoraporateTabs = [
    {
      name: 'Funds (' + fundsStore.allFunds.length + ')',
      isActive: type === INV_TYPE_TABS.FUNDS,
      onClick: () => {
        navigate(
          paths.ALL_INVESTMENTS +
            '?params=' +
            encodeAllInvestmentsParams({ ...params, tab: INV_TYPE_TABS.FUNDS, page: 1 })
        );
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    {
      name: 'Portfolio companies (' + fundsStore.allPortfolios.length + ')',
      isActive: type === INV_TYPE_TABS.PORTFOLIOS,
      onClick: () => {
        navigate(
          paths.ALL_INVESTMENTS +
            '?params=' +
            encodeAllInvestmentsParams({ ...params, tab: INV_TYPE_TABS.PORTFOLIOS, page: 1 })
        );
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  ];

  const corporateTabs = [
    {
      name: 'Invest profiles (' + fundsStore.allInvestProfiles.length + ')',
      onClick: () => {
        // navigate(
        //   paths.ALL_INVESTMENTS +
        //     '?params=' +
        //     encodeAllInvestmentsParams({ ...params, tab: INV_TYPE_TABS.INVEST_PROFILES, page: 1 })
        // );
      },
      noCursor: true
    }
  ];

  const tabs = authStore.isCoraporatesInvestor ? corporateTabs : nonCoraporateTabs;
  const showPaging = list.length > invTypePageSize;
  const pages = Math.ceil(list.length / invTypePageSize) || 1;

  return (
    <>
      <div className="tabs">
        {tabs.map((tab) => {
          const classNames = ['tab'];
          if (tab.isActive) {
            classNames.push('active');
          }
          if (tab.noCursor) {
            classNames.push('no-cursor');
          }
          return (
            <div className={classNames.join(' ')} key={tab.name} onClick={tab.onClick}>
              {tab.name}
            </div>
          );
        })}
      </div>
      <div className="table-responsive">
        {!!list.length && (
          <div className="header">
            <div className="item name">
              {/* {type === INV_TYPE_TABS.FUNDS
                ? 'Fund name'
                : type === INV_TYPE_TABS.PORTFOLIOS
                ? 'Portfolio name'
                : 'Invest name'} */}
              Name
            </div>
            <div className="item industries">Industries</div>
            <div className="item geographies">Geo focus</div>
            <div className="item enterprise-value">EV (€M)</div>
            <div className="item equity-value">EQV (€M)</div>
            <div className="item owner-by">Owned by</div>
            <div className="item latest-change">Changed</div>
            <div className="item actions"></div>
          </div>
        )}
        {list
          .slice((params.page - 1) * invTypePageSize, params.page * invTypePageSize)
          .map((entry) => (
            <AllInvestmentsListEntry key={entry.id} entry={entry} type={type} />
          ))}
      </div>
      <Pagination
        show={showPaging}
        onPageChange={(selected) => {
          navigate(
            paths.ALL_INVESTMENTS +
              '?params=' +
              encodeAllInvestmentsParams({ ...params, page: selected + 1 })
          );
          window.scrollTo({ top: state.layout === 'mobile' ? 0 : 16, behavior: 'smooth' });
        }}
        page={params.page - 1}
        pages={pages}
      />
    </>
  );
});

export default AllInvestmentsList;
